module.exports = __webpack_public_path__ + "img/googleplay.3ea1d84f.svg";